import { KatButton, KatCard, KatIcon } from "@amzn/katal-react";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";

interface NestPanelProps {
  title: string;
  icon?: React.ReactNode;
  onClose?: () => void;
  onBack?: () => void;
  closeAriaLabel?: string;
  backAriaLabel?: string;
  headerActions?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  ariaLabel?: string;
  noPadding?: boolean;
}

export function NestPanel({
  title,
  icon,
  onClose,
  onBack,
  closeAriaLabel,
  backAriaLabel,
  headerActions,
  footer,
  children,
  ariaLabel,
  noPadding,
}: NestPanelProps) {
  const { t } = useTranslation();

  return (
    <KatCard
      className="nest-panel"
      aria-label={ariaLabel ?? title}
      noBodyPadding={noPadding}
    >
      <span slot="title" className="nest-panel-header-title">
        {onBack && (
          <button
            type="button"
            className="nest-panel-back"
            onClick={onBack}
            aria-label={backAriaLabel ?? t("aic_nest_panel_back_label")}
          >
            <KatIcon name="chevron-left" size="small" />
          </button>
        )}
        {icon && <span className="nest-panel-header-icon">{icon}</span>}
        {title}
      </span>
      {(headerActions || onClose) && (
        <span slot="action" className="nest-panel-actions">
          {headerActions}
          {onClose && (
            <KatButton
              className="nest-panel-close"
              variant="link"
              label=""
              onClick={onClose}
              aria-label={closeAriaLabel ?? t("aic_nest_panel_close_label")}
            >
              <KatIcon name="close" size="small" />
            </KatButton>
          )}
        </span>
      )}
      <div className="nest-panel-body">{children}</div>
      {footer && <div slot="footer">{footer}</div>}
    </KatCard>
  );
}
